import { AUTH_RESTORE } from "../actions/auth";
import {
  ICON_NAME_ARTIST,
  ICON_NAME_NEWS,
  ICON_NAME_FANBOX,
  ICON_NAME_CLUB,
  ICON_NAME_PROMOTION,
  ICON_NAME_TEAM,
  ICON_NAME_EVENTS,
  ICON_NAME_COMPETITION,
  ICON_NAME_OPPONENTS,
  ICON_NAME_SETTINGS,
  ICON_NAME_MEMBERS,
  ICON_NAME_LEGAL,
  ICON_NAME_BANNER,
  ICON_NAME_SHOP,
  ICON_NAME_STREAM,
  ICON_NAME_MICROPHONE,
  ICON_NAME_DASHBOARD,
  ICON_NAME_FAN_FEED
} from "../components/Icons/constants";
import { UserRole } from "../types";
import Club from "../api/club";
import config from "config";
import { environment } from "./../utilites/helpers";

interface ILiveSiteModuleConfig {
  name: string;
  icon: string;
  access: UserRole[];
  link: string;
  target?: string;
  external?: boolean;
}

interface ILiveSiteModuleConfigGroup {
  name: string;
  icon: string;
  access: UserRole[];
  children?: (ILiveSiteModuleConfig | ILiveSiteModuleConfigGroup)[];
}

export interface ILiveSiteClubConfig {
  club: Club;
  modules: (ILiveSiteModuleConfig | ILiveSiteModuleConfigGroup)[];
}

export class InfoCmsModuleConfig implements ILiveSiteModuleConfig {
  access: UserRole[];
  link: string;
  protected _addRichText: boolean = false;
  protected _addTwoColumn: boolean = false;
  protected _addPlayers: boolean = false;
  protected _addTransfers: boolean = false;

  constructor(public name: string, public icon: string) {
    this.access = ["EM"];
    this.link = "/info";
  }

  get addTransfers(): boolean {
    return this._addTransfers;
  }

  get addPlayers(): boolean {
    return this._addPlayers;
  }

  get addTwoColumn(): boolean {
    return this._addTwoColumn;
  }

  get addRichText(): boolean {
    return this._addRichText;
  }
}

class ArtistInfoCmsModuleConfig extends InfoCmsModuleConfig {
  constructor(name: string, icon: string) {
    super(name, icon);
    this._addRichText = true;
  }
}

class ClubInfoCmsModuleConfig extends InfoCmsModuleConfig {
  constructor(name: string, icon: string) {
    super(name, icon);
    this._addRichText = true;
    this._addPlayers = false;
    this._addTransfers = false;
    this._addTwoColumn = true;
  }
}

let getClubInfoModuleConfig = name => {
  return new ClubInfoCmsModuleConfig(name, ICON_NAME_CLUB);
};

const ArtistInfoModuleConfig = new ArtistInfoCmsModuleConfig(
  "Artist",
  ICON_NAME_ARTIST,
);

const initState: ILiveSiteClubConfig = {
  club: null,
  modules: [],
};
const TeamModuleConfig: ILiveSiteModuleConfig = {
  name: "Team",
  icon: ICON_NAME_TEAM,
  access: ["PM", "EM"],
  link: "/players",
};
const AccountsManagmentModuleConfig: ILiveSiteModuleConfig = {
  name: "About Us",
  icon: ICON_NAME_CLUB,
  access: ["PM"],
  link: "/clubs",
};

const CityEventsModuleConfig: ILiveSiteModuleConfig = {
  name: "Events",
  icon: ICON_NAME_CLUB,
  access: ["PM", "EM"],
  link: "/city_events",
};

const NewsModuleConfig: ILiveSiteModuleConfig = {
  name: "News",
  icon: ICON_NAME_NEWS,
  access: ["PM", "EM"],
  link: "/news",
};
const FanBoxModuleConfig: ILiveSiteModuleConfig = {
  name: "Inbox",
  icon: ICON_NAME_FANBOX,
  access: ["PM", "EM"],
  link: "/fanbox",
};
const PromotionsModuleConfig: ILiveSiteModuleConfig = {
  name: "Promotion",
  icon: ICON_NAME_PROMOTION,
  access: ["PM", "EM"],
  link: "/promotion",
};
const BuetzerBuebeFanBoxModuleConfig: ILiveSiteModuleConfig = {
  name: "Geils Züüg Message",
  icon: ICON_NAME_FANBOX,
  access: ["PM", "EM"],
  link: "/fanbox",
};
const BuetzerBuebePromotionsModuleConfig: ILiveSiteModuleConfig = {
  name: "Geils Züüg – Promo",
  icon: ICON_NAME_FANBOX,
  access: ["PM", "EM"],
  link: "/promotion",
};
const EventsModuleConfig: ILiveSiteModuleConfig = {
  name: "Events",
  icon: ICON_NAME_EVENTS,
  access: ["PM", "EM"],
  link: "/events",
};
const CompetitionModuleConfig: ILiveSiteModuleConfig = {
  name: "Competition",
  icon: ICON_NAME_COMPETITION,
  access: ["PM", "EM"],
  link: "/raffles",
};
const FanFeedModuleConfig: ILiveSiteModuleConfig = {
  name: "Fan Feed",
  icon: ICON_NAME_FAN_FEED,
  access: ["PM", "EM"],
  link: "/fanfeed",
};
const OpponentsModuleConfig: ILiveSiteModuleConfig = {
  name: "Opponents",
  icon: ICON_NAME_OPPONENTS,
  access: ["PM", "EM"],
  link: "/participants",
};
const SettingsModuleConfig: ILiveSiteModuleConfigGroup = {
  name: "Settings",
  icon: ICON_NAME_SETTINGS,
  access: ["PM"],
  children: [
    AccountsManagmentModuleConfig,
    {
      name: "User Management",
      icon: ICON_NAME_MEMBERS,
      access: ["PM"],
      link: "/managers",
    },
    {
      name: "Legal",
      icon: ICON_NAME_LEGAL,
      access: ["PM"],
      link: "/settings",
    },
  ],
};

const BuetzerBuebeSettingsModuleConfig: ILiveSiteModuleConfigGroup = {
  name: "Iistellige",
  icon: ICON_NAME_SETTINGS,
  access: ["PM"],
  children: [
    {
      name: "Über Üs",
      icon: ICON_NAME_MICROPHONE,
      access: ["PM"],
      link: "/clubs",
    },
    {
      name: "User Management",
      icon: ICON_NAME_MEMBERS,
      access: ["PM"],
      link: "/managers",
    },
    {
      name: "Legal",
      icon: ICON_NAME_LEGAL,
      access: ["PM"],
      link: "/settings",
    },
  ],
};

const ShopModuleConfigWithSubdomain = (subdomain: String): ILiveSiteModuleConfigGroup => ({
  ...ShopModuleConfig, children: [{
    ...ShopModuleConfig.children[0],
    link: `https://${subdomain}.${config.baseDomain}/admin`},
    ShopModuleConfig.children[1]]
})

const ShopModuleConfig: ILiveSiteModuleConfigGroup = {
  name: "Shop",
  icon: ICON_NAME_SHOP,
  access: ["PM", "EM"],
  children: [
    {
      name: 'Shop Admin',
      icon: ICON_NAME_SHOP,
      access: ['PM', 'EM'],
      link: `https://${config.subDomain.replace('cpanel', 'shop')}.${config.baseDomain}/admin`,
      external: true
    },
    {
      name: 'Shop payments',
      icon: ICON_NAME_SHOP,
      access: ['PM', 'EM'],
      link: '/shop/stripe',
    }
  ],
};

const BannerModuleConfig: ILiveSiteModuleConfig = {
  name: "Banners",
  icon: ICON_NAME_BANNER,
  access: ["PM", "EM"],
  link: "/banners",
};

const StreamModuleConfig: ILiveSiteModuleConfig = {
  name: "Stream",
  icon: ICON_NAME_STREAM,
  access: ["PM", "EM"],
  link: !config.useFakeStream ? "/stream" : "/stream",
};

const clubStatus: { [key: string]: ILiveSiteClubConfig } = {
  // Maurice_Lacroix
  "96895b04-292c-44ec-9252-24f506c21e93": {
    club: null,
    modules: [
      getClubInfoModuleConfig("About Us"),
      NewsModuleConfig,
      FanBoxModuleConfig,
      PromotionsModuleConfig,
      ShopModuleConfig,
      // EventsModuleConfig,
      CompetitionModuleConfig,
      FanFeedModuleConfig,
      StreamModuleConfig,
      SettingsModuleConfig,
      BannerModuleConfig,
      {
        name: "Dashboard",
        icon: ICON_NAME_DASHBOARD,
        access: ["PM", "EM"],
        link: `https://console.firebase.google.com/u/0/project/live-83c75/overview`,
        external: true
      }
    ],
  },
  // live.demo
  "c03979b2-8a8e-11ec-a8a3-0242ac120002": {
    club: null,
    modules: [
      getClubInfoModuleConfig("About Us"),
      NewsModuleConfig,
      FanBoxModuleConfig,
      PromotionsModuleConfig,
      ShopModuleConfig,
      EventsModuleConfig,
      CompetitionModuleConfig,
      FanFeedModuleConfig,
      StreamModuleConfig,
      SettingsModuleConfig,
      BannerModuleConfig,
      {
        name: "Dashboard",
        icon: ICON_NAME_DASHBOARD,
        access: ["PM", "EM"],
        link: `https://console.firebase.google.com/u/0/project/live-83c75/overview`,
        external: true
      }
    ],
  },
  // msalgado
  "fccca4e0-0640-4c9e-9f55-dbede0245314": {
    club: null,
    modules: [
      getClubInfoModuleConfig("About Us"),
      NewsModuleConfig,
      FanBoxModuleConfig,
      PromotionsModuleConfig,
      ShopModuleConfig,
      EventsModuleConfig,
      CompetitionModuleConfig,
      FanFeedModuleConfig,
      StreamModuleConfig,
      SettingsModuleConfig,
      BannerModuleConfig,
      {
        name: "Dashboard",
        icon: ICON_NAME_DASHBOARD,
        access: ["PM", "EM"],
        link: `https://console.firebase.google.com/u/0/project/live-83c75/overview`,
        external: true,
      },
    ],
  },
  // RollingStones
  "36b92e17-2966-4d55-a3da-f59f29e3db2f": {
    club: null,
    modules: [
      getClubInfoModuleConfig("About Us"),
      NewsModuleConfig,
      FanBoxModuleConfig,
      PromotionsModuleConfig,
      ShopModuleConfigWithSubdomain("shop-rolling-stones-stage"),
      // EventsModuleConfig,
      CompetitionModuleConfig,
      FanFeedModuleConfig,
      StreamModuleConfig,
      SettingsModuleConfig,
      BannerModuleConfig,
      {
        name: "Dashboard",
        icon: ICON_NAME_DASHBOARD,
        access: ["PM", "EM"],
        link: `https://console.firebase.google.com/u/0/project/live-83c75/overview`,
        external: true
      }
    ],
  },
  // Nocturne
  "16aa606c-2906-466e-a7c1-5113db784e30": {
    club: null,
    modules: [
      getClubInfoModuleConfig("About Us"),
      NewsModuleConfig,
      FanBoxModuleConfig,
      PromotionsModuleConfig,
      ShopModuleConfig,
      // EventsModuleConfig,
      CompetitionModuleConfig,
      FanFeedModuleConfig,
      StreamModuleConfig,
      CityEventsModuleConfig,
      BannerModuleConfig,
      SettingsModuleConfig,
      {
        name: "Dashboard",
        icon: ICON_NAME_DASHBOARD,
        access: ["PM", "EM"],
        link: `https://console.firebase.google.com/u/0/project/nocturne-353405/overview`,
        external: true
      }
    ],
  },
  // simplyBEN
  "063ab0b1-e966-47f5-bc0e-ad5dde7bab12": {
    club: null,
    modules: [
      getClubInfoModuleConfig("About Us"),
      NewsModuleConfig,
      FanBoxModuleConfig,
      PromotionsModuleConfig,
      ShopModuleConfig,
      // EventsModuleConfig,
      CompetitionModuleConfig,
      FanFeedModuleConfig,
      StreamModuleConfig,
      BannerModuleConfig,
      SettingsModuleConfig,
      {
        name: "Dashboard",
        icon: ICON_NAME_DASHBOARD,
        access: ["PM", "EM"],
        link: `https://console.firebase.google.com/u/0/project/simplyben-84dd2/overview`,
        external: true
      }
    ],
  },
  // lenovo
  "e2952c70-69fd-489a-bf0a-8b982c8606aa": {
    club: null,
    modules: [
      getClubInfoModuleConfig("About Us"),
      NewsModuleConfig,
      FanBoxModuleConfig,
      PromotionsModuleConfig,
      ShopModuleConfig,
      CompetitionModuleConfig,
      FanFeedModuleConfig,
      StreamModuleConfig,
      SettingsModuleConfig,
      BannerModuleConfig,
      {
        name: "Dashboard",
        icon: ICON_NAME_DASHBOARD,
        access: ["PM", "EM"],
        link: `https://console.firebase.google.com/project/buetzerbuebe-a95f8/overview`,
        external: true
      }
    ],
  },
  // nitinsawheny
  "80bb6008-c287-4722-96a4-29b6b64a36d8": {
    club: null,
    modules: [
      ArtistInfoModuleConfig,
      NewsModuleConfig,
      FanBoxModuleConfig,
      PromotionsModuleConfig,
      ShopModuleConfig,
      StreamModuleConfig,
      SettingsModuleConfig,
      BannerModuleConfig,
    ],
  },
  // ManchesterCity
  "9d1c8f5a-6477-40cb-b44b-d1e4667ced5b": {
    club: null,
    modules: [
      getClubInfoModuleConfig("Club"),
      TeamModuleConfig,
      NewsModuleConfig,
      FanBoxModuleConfig,
      PromotionsModuleConfig,
      ShopModuleConfig,
      EventsModuleConfig,
      StreamModuleConfig,
      OpponentsModuleConfig,
      SettingsModuleConfig,
      BannerModuleConfig,
    ],
  },
  // buetzer buebe
  "80f53ef6-6373-11ea-bc55-0242ac130003": {
    club: null,
    modules: [
      getClubInfoModuleConfig("Über Üs"),
      NewsModuleConfig,
      BuetzerBuebeFanBoxModuleConfig,
      BuetzerBuebePromotionsModuleConfig,
      ShopModuleConfig,
      // EventsModuleConfig,
      CompetitionModuleConfig,
      FanFeedModuleConfig,
      StreamModuleConfig,
      BuetzerBuebeSettingsModuleConfig,
      BannerModuleConfig,
      {
        name: "Dashboard",
        icon: ICON_NAME_DASHBOARD,
        access: ["PM", "EM"],
        link: `https://console.firebase.google.com/project/buetzerbuebe-a95f8/overview`,
        external: true
      }
    ],
  },
  // LiVE Nightlife
  "dd8af89b-65fa-48ba-8aa3-462e0500a677": {
    club: null,
    modules: [
      getClubInfoModuleConfig("About Us"),
      NewsModuleConfig,
      FanBoxModuleConfig,
      PromotionsModuleConfig,
      ShopModuleConfig,
      CompetitionModuleConfig,
      FanFeedModuleConfig,
      StreamModuleConfig,
      SettingsModuleConfig,
      BannerModuleConfig,
      {
        name: "Dashboard",
        icon: ICON_NAME_DASHBOARD,
        access: ["PM", "EM"],
        link: `https://console.firebase.google.com/u/0/project/live-83c75/overview`,
        external: true
      }
    ],
  },
  // Footballerista
  "d6322683-cf56-4173-9411-85a950727c80": {
    club: null,
    modules: [
      getClubInfoModuleConfig("About Us"),
      NewsModuleConfig,
      FanBoxModuleConfig,
      PromotionsModuleConfig,
      ShopModuleConfig,
      CompetitionModuleConfig,
      FanFeedModuleConfig,
      StreamModuleConfig,
      SettingsModuleConfig,
      BannerModuleConfig,
      {
        name: "Dashboard",
        icon: ICON_NAME_DASHBOARD,
        access: ["PM", "EM"],
        link: `https://console.firebase.google.com/u/0/project/live-83c75/overview`,
        external: true
      }
    ],
  },
  //Metropolis
  "7e4043e4-72f4-4891-b87d-31fbcca10284": {
    club: null,
    modules: [
      getClubInfoModuleConfig("About Us"),
      NewsModuleConfig,
      FanBoxModuleConfig,
      PromotionsModuleConfig,
      StreamModuleConfig,
      {
        name: "Shop",
        icon: ICON_NAME_SHOP,
        access: ["PM", "EM"],
        link:
          "https://shop-metropolis" +
          environment +
          ".liveapps.ch/login/ ",
        target: "_blank",
      },
      SettingsModuleConfig,
      BannerModuleConfig,
      {
        name: "Legal",
        icon: ICON_NAME_LEGAL,
        access: ["PM", "EM"],
        link: "/settings",
      },
    ],
  },
  //Sportapp
  "ed4a283c-2499-4295-b91c-0435922c9b22": {
    club: null,
    modules: [
      getClubInfoModuleConfig("About Us"),
      NewsModuleConfig,
      FanBoxModuleConfig,
      PromotionsModuleConfig,
      EventsModuleConfig,
      OpponentsModuleConfig,
      StreamModuleConfig,
      {
        name: "Shop",
        icon: ICON_NAME_SHOP,
        access: ["PM", "EM"],
        link:
          "https://shop-sportapp" +
          environment +
          ".liveapps.ch/login ",
        target: "_blank",
      },
      SettingsModuleConfig,
      BannerModuleConfig,
      {
        name: "Legal",
        icon: ICON_NAME_LEGAL,
        access: ["EM"],
        link: "/settings",
      },
    ],
  },
  //Patrick
  "822034c4-8064-4a78-84c4-7a777ec272b3": {
    club: null,
    modules: [
      getClubInfoModuleConfig("About Us"),
      NewsModuleConfig,
      FanBoxModuleConfig,
      PromotionsModuleConfig,
      EventsModuleConfig,
      OpponentsModuleConfig,
      StreamModuleConfig,
      {
        name: "Shop",
        icon: ICON_NAME_SHOP,
        access: ["PM", "EM"],
        link:
          "https://shop-patrick" +
          environment +
          ".liveapps.ch/login ",
        target: "_blank",
      },
      SettingsModuleConfig,
      BannerModuleConfig,
      {
        name: "Legal",
        icon: ICON_NAME_LEGAL,
        access: ["EM"],
        link: "/settings",
      },
    ],
  },
};

// "live flutter #1", "live flutter #2" the same as "live demo",  the same as "stadium grouppe"

clubStatus["5c274ecc-d5d5-4b4e-8b00-c57593b0711b"] = //stadium grouppe
clubStatus["c03979b2-8a8e-11ec-a8a3-0242ac120003"] = // live sandbox
clubStatus["d194a18b-a00c-45a8-8c70-111111111111"] =
clubStatus["d194a18b-a00c-45a8-8c70-222222222222"] =
  clubStatus["c03979b2-8a8e-11ec-a8a3-0242ac120002"]

export default function(state = initState, action) {
  let { type, user } = action;
  switch (type) {
    case AUTH_RESTORE:
      let club = user.club;
      return Object.assign({}, state, clubStatus[club.id], {
        club,
      });

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/club-settings.ts